"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GiftBoxLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var GiftBoxLinear = function GiftBoxLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.754 4.765l-.062.035H14.4a.8.8 0 01.8.8v3.2a.8.8 0 01-.8.8v4.8a.8.8 0 01-.8.8H2.4a.8.8 0 01-.8-.8V9.6a.8.8 0 01-.8-.8V5.6a.8.8 0 01.8-.8h2.708a2.7 2.7 0 01-.221-.129C3.204 4.1 2.7 3.278 2.7 2.418 2.7 1.268 3.6.4 4.795.4 5.993.4 7.208 1.29 8 2.6 8.792 1.29 10.01.4 11.215.4c1.189 0 2.085.866 2.085 2.016 0 .86-.505 1.681-1.385 2.254-.051.034-.106.064-.16.095zM11.215 2c-.609 0-1.575.73-2.114 1.94.984-.117 1.587-.38 1.941-.611.412-.268.658-.61.658-.913 0-.26-.182-.416-.485-.416zM7.2 6.4H2.4V8h4.8V6.4zm1.6 0V8h4.8V6.4H8.8zM7.2 9.6h-4v4h4v-4zm1.6 4v-4h4v4h-4zM4.3 2.418c0-.262.185-.418.495-.418.62 0 1.573.717 2.107 1.94-.986-.116-1.59-.38-1.944-.61-.412-.268-.658-.609-.658-.912z",
    fill: "currentColor"
  }));
};

exports.GiftBoxLinear = GiftBoxLinear;
var _default = GiftBoxLinear;
exports.default = _default;